import type { ReactElement, SyntheticEvent } from "react";

import {
    StyledScrollableTooltipItem,
    StyledScrollableTooltipList,
} from "app/pages/sales-intelligence/sub-modules/signals/components/shared/SignalSelectionTooltipList/styles";

type Props = {
    labels: readonly string[];
};

const SignalSelectionTooltipList = ({ labels }: Props): ReactElement => {
    const stopWheelPropagation = (event: SyntheticEvent): void => {
        event.stopPropagation();
    };

    return (
        <StyledScrollableTooltipList
            data-automation="signal-selection-tooltip-list"
            onWheel={stopWheelPropagation}
        >
            {labels.map((label, index) => (
                <StyledScrollableTooltipItem key={`${label}-${index}`}>{label}</StyledScrollableTooltipItem>
            ))}
        </StyledScrollableTooltipList>
    );
};

export default SignalSelectionTooltipList;
